__turbopack_context__.v({
  "icon": "SlideButton-module__f5WPpG__icon",
  "iconCircle": "SlideButton-module__f5WPpG__iconCircle",
  "iconTrack": "SlideButton-module__f5WPpG__iconTrack",
  "label": "SlideButton-module__f5WPpG__label",
  "reverse": "SlideButton-module__f5WPpG__reverse",
  "root": "SlideButton-module__f5WPpG__root",
  "slideButtonRoll": "SlideButton-module__f5WPpG__slideButtonRoll",
  "slideButtonRollBack": "SlideButton-module__f5WPpG__slideButtonRollBack",
});
